module.exports = __webpack_public_path__ + "static/media/close-x.2c1256a4.svg";